import { makeAutoObservable } from "mobx";
import { PathType } from "../components/main/sidebar/components/paths/PathType";
import { IRootStore } from "./RootStore";

export class HeaderPathStore {
    path: PathType[] = [];

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setPath = (path: PathType[]) => {
        this.path = path;
    }
    get getPath() {
        return this.path;
    }
}